import { pairwise } from 'rxjs/operators';
import { forEach } from 'lodash';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IEOtpremnicaDto, NacinOtpreme, StavkaOtpremniceDto } from '@kodit/core/data-api';
import { FormGroupTypeSafe } from 'angular-typesafe-reactive-forms-helper';
import { Subscription } from 'rxjs';
import { EOtpremnicaForm, EotpremnicaFormService } from '../../otpremnice/eotpremnica-form.service';
import { Form, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'kodit-faze-voznje',
  templateUrl: './faze-voznje.component.html',
  styleUrls: ['./faze-voznje.component.scss']
})
export class FazeVoznjeComponent implements OnInit, OnDestroy {

  /** Subs */
  private _subs: Subscription = new Subscription();

  nacinOtpreme: NacinOtpreme = null;
  jeLicniNacinOtpreme : boolean = false;
  jePrevoznik : boolean = false;
  //fazeVoznje : FormArray;
  jeEdit : boolean= false;


  /** I/O */
  @Input() otpremnicaFormGroup: FormGroupTypeSafe<IEOtpremnicaDto>;

  constructor(
    private _formService: EotpremnicaFormService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {

    if(this._formService._isInitialized)
    {
      this.jeEdit = true;
      this.nacinOtpreme = this._formService.nacinOtpremeSubject.value;
      this.jeLicniNacinOtpreme = this._formService.nacinOtpremeSubject.value === NacinOtpreme.LICNA_DOSTAVA
        || this._formService.nacinOtpremeSubject.value === NacinOtpreme.LICNO_PREUZIMANJE;
      this.jePrevoznik = this._formService.nacinOtpremeSubject.value === NacinOtpreme.PREVOZNIK
      if(!this.jeLicniNacinOtpreme && this.nacinOtpreme != null)
      {
        this._setValidatorsFaze();
      }else if(this.jeLicniNacinOtpreme && this.nacinOtpreme != null){
          this.otpremnicaFormGroup?.controls.licniNacinOtpreme?.get('ime')?.setValidators([Validators.required]);
          this.otpremnicaFormGroup?.controls.licniNacinOtpreme?.get('prezime')?.setValidators([Validators.required]);
          this.otpremnicaFormGroup?.controls.licniNacinOtpreme?.get('brojLicneKarte')?.setValidators([Validators.required]);
      }
    }

    this._subs.add(
      this._formService.nacinOtpreme$.subscribe((value) => {

        if(!this.jeEdit){
          this._resetFormAndValidation();
          this.nacinOtpreme = value;
          //this._formService.getFazeVoznjeArray.reset();
          this.jeLicniNacinOtpreme = value === NacinOtpreme.LICNA_DOSTAVA || value === NacinOtpreme.LICNO_PREUZIMANJE;

          this.jePrevoznik = value === NacinOtpreme.PREVOZNIK
          if(!this.jeLicniNacinOtpreme && this.nacinOtpreme != null)
          {
            this.dodajFazu();
          }else if(this.jeLicniNacinOtpreme && this.nacinOtpreme != null){
            this.otpremnicaFormGroup?.controls.licniNacinOtpreme?.get('ime')?.setValidators([Validators.required]);
            this.otpremnicaFormGroup?.controls.licniNacinOtpreme?.get('prezime')?.setValidators([Validators.required]);
            this.otpremnicaFormGroup?.controls.licniNacinOtpreme?.get('brojLicneKarte')?.setValidators([Validators.required]);
          }
        }
        this.jeEdit = false;
      })
    );
  }

  get fazeVoznje(): FormArray {
    return this._formService.getFazeVoznjeArray;
  }

  dodajFazu(): void {
    const idx = this.fazeVoznje.length;
    const novaFaza = this._formService.getFazaVoznjeFormGroup({
      redniBroj: idx + 1,
    });
    this.fazeVoznje.push(novaFaza);
    const vozacGroup = novaFaza.get('vozacDto') as FormGroup;
    if (vozacGroup) {
      vozacGroup.get('registarskiBrojVozila')?.setValidators([Validators.required]);
      vozacGroup.get('registarskiBrojVozila')?.updateValueAndValidity();
    }
    // if(this.nacinOtpreme == NacinOtpreme.PREVOZ_PRIMAOCA || this.nacinOtpreme == NacinOtpreme.SOPSTVENI_PREVOZ)
    // {
    //   novaFaza.removeControl('prevoznikDto');
    // }
  }

  private _resetFormAndValidation(): void
  {
    const licni = this.otpremnicaFormGroup.get('licniNacinOtpreme') as FormGroup;
    if (licni) {
      licni.get('ime')?.clearValidators();
      licni.get('prezime')?.clearValidators();
      licni.get('brojLicneKarte')?.clearValidators();
      licni.reset();
      licni.updateValueAndValidity();
    }

    if (this.fazeVoznje?.length) {
      this.fazeVoznje.controls.forEach(faza => {
        const vozac = faza.get('vozacDto') as FormGroup;
        if (vozac) {
          vozac.get('registarskiBrojVozila')?.clearValidators();
          vozac.updateValueAndValidity();
        }

        const prevoznik = faza.get('prevoznikDto') as FormGroup;
        if (prevoznik) {
          prevoznik.reset();
          prevoznik.get('naziv')?.clearValidators();
          prevoznik.updateValueAndValidity();
        }
      });

      this._formService.getFazeVoznjeArray.clear();
    }
  }

  private _setValidatorsFaze(): void {
    const fazeArray = this.fazeVoznje;

    fazeArray.controls.forEach((fazaGroup: FormGroup) => {
      const vozacGroup = fazaGroup.get('vozacDto') as FormGroup;
      if (vozacGroup) {
        vozacGroup.get('registarskiBrojVozila')?.setValidators([Validators.required]);
        vozacGroup.get('registarskiBrojVozila')?.updateValueAndValidity();
      }
      // if (this.nacinOtpreme === NacinOtpreme.PREVOZ_PRIMAOCA || this.nacinOtpreme === NacinOtpreme.SOPSTVENI_PREVOZ) {
      //   fazaGroup.removeControl('prevoznikDto');
      // }
    });
  }


  delete(index: any): void {
    this.fazeVoznje.removeAt(index);
    this._updateRedneBrojeve();
  }

  private _updateRedneBrojeve() {
    this.fazeVoznje.value.forEach((s: StavkaOtpremniceDto, i: number) => {
      this.fazeVoznje
        .at(i)
        .get('redniBroj')
        .patchValue(i + 1);
    });
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

}
